module.exports = __webpack_public_path__ + "img/logowhite.2af1a960.png";